export default "__VITE_ASSET__d3825b69__"